import React from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";

const EventPlanningTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
  occasions,
  themes,
  services,
}) => {
  const { t } = useTranslation();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <Box>
      <Stack
        direction="row"
        alignSelf="start"
        justifyContent="start"
        gap={2}
        width="100%"
      >
        <Breadcrumb data={breadcrumbs} />
      </Stack>
      <CCrud
        detailsTemplateData={{
          pageTitle: t("event_planning.title"),
          data: {
            list: [],
          },
        }}
        table={{
          list: data,
          listTitle: t("event_planning.requests"),
          columns: [
            { accessor: "id", Header: "#" },
            {
              accessor: "environment",
              Header: t("event_planning.environment"),
            },
            {
              accessor: "day_period",
              Header: t("event_planning.day_period"),
            },
            {
              accessor: "occasion_type.name",
              Header: t("event_planning.occasion"),
            },
            { accessor: "status", Header: t("event_planning.status") },
            { accessor: "event_date", Header: t("event_planning.event_date") },
            { accessor: "budget", Header: t("event_planning.budget") },
            { accessor: "Actions", Header: t("common.action_actions") },
          ],
          isSearch: false,
          searchInputPlaceholder: t("event_planning.search_placeholder"),
          isChecked: false,
          total_count: count,
          setFilterObj,
          className:
            "organization-table system-configurations-table main-table",
          paginationPage: paginationPage,
          handlePageChange,
          rowData: rowData,
          filterList,
          actionsList,
          headerChildren,
          details,
        }}
        form={{
          initialValues: !id
            ? {}
            : initialValues(details, occasions, themes, services, t),
          structure: () => structure(occasions, themes, services, t),
          validationSchema: validationSchema(t),
          title: id ? t("event_planning.edit") : t("event_planning.add"),
          submitTitle: id
            ? t("admin_users.btn_update")
            : t("admin_users.btn_add"),
          onSubmit: handelSubmit,
          className: { form: "main-form", actionButton: "main-form-buttons" },
        }}
        modalComponents={modalComponents}
      />
    </Box>
  );
};

export default EventPlanningTemplate;
